import React from 'react'

const HomeBanner = () => {
    return (
        <>
            {/* Space */}
            <div className="py-5 pt-md-5 mt-md-3" />

            <div id="home-banner" className="col-10 mx-auto ps-md-3">
                <h1 className="fw-500 text-white fs-home-banner text-uppercase lh-sm">
                    Dubai Real Estate Agency
                    <br className="d-none d-md-block" />
                    Helping You{' '}
                    <span className="fw-700">
                        {' '}
                        Buy, Sell <br className="d-none d-md-block" /> & Invest Smartly{' '}
                    </span>
                </h1>
                {/* <h2 className="text-white fs-sub-home-banner fw-400 pt-2 pt-md-3">
                     Turning Property Dreams <br className="d-block d-md-none" /> into Reality
                </h2> */}
            </div>
        </>
    )
}

export default HomeBanner
